import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
		active_organisation: null,
    }),
	getters: {
		can() {
			return (permission, relationship = null, relatedIds = null) => {

				// if relationship is null, check against the active organisation
				if( !relationship ) {
					relationship = 'organisations'
					relatedIds = [this.active_organisation?.id]
				}

				// relatedIds may be an array or a single id
				if( !Array.isArray(relatedIds) ) {
					relatedIds = [relatedIds]
				}
				
				// if we don't have a user, they can't do anything
				if (!this.user) {
					return false
				}
				// admins can do everything
				if (this.isAdmin) {
					return true
				}
				// if the user has no permissions, they can't do anything
				if (!this.user.permissions) {
					return false
				}

				// otherwise check the relationship permissions
				if (
					this.user.permissions[relationship] &&
					this.user.permissions[relationship].find((p) => relatedIds.includes(p.id))
				) {
					return this.user.permissions[relationship].find((p) => relatedIds.includes(p.id))
						.role.permissions.includes(permission)
				}
				return false
			}
		},
		role() {
			return this.user ? this.user.role : null
		},
		isAdmin() {
			return this.role ? this.role == "admin" : false
		},
		id() {
			return this.user ? this.user.id : null
		},
		// given a permission string, return all records that the user has that permission on.
		// optionally pass in a relationship name to bracket the search to a specific relationship
		whereCan() {
			return (permission, relationship = null) => {
				// if we have no user then there aren't any permissions
				if (!this.user) {
					return []
				}

				let keys = Object.keys(this.user.permissions)
				let related = []
				keys.forEach((key) => {
					// if we have a passed relationship, only look for that relationship
					if( relationship && key != relationship ) {
						return
					}

					this.user.permissions[key].forEach((model) => {
						if (model.role.permissions.includes(permission)) {
							related.push({
								relationship: key,
								id: model.id,
							})
						}
					})
				})
				return related
			}
		}
	},
    actions: {
        set(auth) {
			// only override if present in auth object (don't override with null)
            this.user = auth.user ? auth.user : this.user
			this.active_organisation = auth.active_organisation ? auth.active_organisation : this.active_organisation
        },
    }
})
